import img1 from '../images/common/itemslider.png';
import roadmapGif from '../images/background/bg-roadmap.gif';
import smilerVideo from '../images/smiler.mp4';
import chimpGangVideo from '../images/chimpGang.mp4';
import cheesyChimpVideo from '../images/cheesyChimp.mp4';
import russianChimpVideo from '../images/russianChimp.mp4';
import luckyChimpVideo from '../images/luckyChimp.mp4';
const dataSlider = [
   
    {
        id: 4,
        eyebrow: 'Bitcoin Ordinals collection',
        title: 'Block Pirates',
        desc : '10,000 distinctive Chimp pirates inscribed on Bitcoin. Built for collectors who want art with attitude, permanent provenance, and a community that actually enjoys the voyage.',
        media : img1,
        mediaType: 'image',
        mediaItems: [
            {
                media: img1,
                mediaType: 'image',
            },
            /*{
                media: roadmapGif,
                mediaType: 'gif',
            },*/
            {
                media: smilerVideo,
                mediaType: 'video',
            },
            {
                media: chimpGangVideo,
                mediaType: 'video',
            },
            {
                media: cheesyChimpVideo,
                mediaType: 'video',
                mediaFit: 'zoom',
            },
             {
                media: russianChimpVideo,
                mediaType: 'video',
                
            },
            {
                media: luckyChimpVideo,
                mediaType: 'video',

            },
        ],
    },
]

export default dataSlider;
